import React, { Fragment, PureComponent } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Input, Form, Column, Link } from '../../..'
import Button from '../../../Button'
import { Frame, FrameContent, BackLink, NullLinkWrapper, StyledList } from './Form.style'
import { propTypes, defaultProps } from './ContentPushForm.props'
import { withSize } from '../../../utils'

const { FormGroup, FormHeader, Label } = Form

class ContentPushForm extends PureComponent {
    static propTypes = propTypes

    static defaultProps = defaultProps

    constructor(props) {
        super(props)

        this.inputToFocus = React.createRef()
    }

    componentDidMount() {
        this.inputToFocus.current.focus()
    }

    get submitLabel() {
        const {
            isNew,
            values: { purchase_order },
        } = this.props

        if (!purchase_order) {
            return 'Draft'
        }

        return isNew ? 'Create' : 'Edit'
    }

    renderEndDateLabel() {
        const { onChange } = this.props

        return (
            <Fragment>
                End Date&nbsp;
                <Link onClick={onChange.date_end_remove}>&times;</Link>
            </Fragment>
        )
    }

    render() {
        const {
            countries,
            errors: {
                countries: errorCountry,
                date_end: errorExpiryDate,
                date_start: errorGoLiveDate,
                group: errorGroup,
                level_required: errorLevel,
                media: errorMedia,
                name: errorName,
                notes: errorNotes,
                playlist: errorPlaylist,
                purchase_order: errorPurchaseOrder,
                status: errorStatus,
            },
            goBack,
            isNew,
            levels,
            groups,
            onChange,
            onChangeDefault,
            onChangeEstate,
            onSubmit,
            optionsPlaylist,
            estates,
            selectedEstate,
            statusList,
            hadPO,
            values: {
                countries: valueCountry,
                date_end: valueExpiryDate,
                date_start: valueGoLiveDate,
                group: valueGroup,
                level_required: valueLevel,
                media: valueMedia,
                name: valueName,
                notes: valueNotes,
                playlist: valuePlaylist,
                purchase_order: valuePurchaseOrder,
                status: valueStatus,
            },
            isMobile,
        } = this.props

        return (
            <Frame>
                <FrameContent>
                    <Form>
                        <FormHeader>
                            {goBack && (
                                <BackLink onClick={goBack}>
                                    <FontAwesomeIcon icon="chevron-left" />
                                    &nbsp;Back
                                </BackLink>
                            )}
                            {isNew ? 'Create New Content Push' : 'Edit Content Push'}
                        </FormHeader>
                        <FormGroup title="Content Push">
                            <Label id="name" label="Description" error={errorName}>
                                <Input
                                    id="name"
                                    name="name"
                                    type="text"
                                    error={!!errorName}
                                    onChange={onChange.name || onChangeDefault}
                                    size={isMobile ? 'md' : 'lg'}
                                    value={valueName}
                                    ref={this.inputToFocus}
                                />
                            </Label>
                            <Label id="level_required" label="Level Required" error={errorLevel}>
                                <Input
                                    id="level_required"
                                    name="level_required"
                                    type="select"
                                    size={isMobile ? 'md' : 'lg'}
                                    error={!!errorLevel}
                                    onChange={onChange.level || onChangeDefault}
                                    value={valueLevel}
                                    values={levels}
                                />
                            </Label>
                            <Label id="purchase_order" label="Purchase Order" error={errorPurchaseOrder}>
                                <Input
                                    id="purchase_order"
                                    name="purchase_order"
                                    type="text"
                                    size={isMobile ? 'md' : 'lg'}
                                    error={!!errorPurchaseOrder}
                                    onChange={onChange.purchase_order || onChangeDefault}
                                    value={valuePurchaseOrder}
                                />
                            </Label>
                        </FormGroup>
                        <FormGroup title="Location">
                            <Label id="estate" label="Estate">
                                <Input
                                    id="estate"
                                    name="estate"
                                    type="select"
                                    size={isMobile ? 'md' : 'lg'}
                                    onChange={onChangeEstate}
                                    value={selectedEstate}
                                    values={estates}
                                />
                            </Label>
                            <Label id="group" label="Group" error={errorGroup}>
                                <Input
                                    id="group"
                                    name="group"
                                    type="select"
                                    error={!!errorGroup}
                                    size={isMobile ? 'md' : 'lg'}
                                    onChange={onChange.group || onChangeDefault}
                                    value={valueGroup}
                                    values={groups}
                                />
                            </Label>
                            {!isNew && hadPO && (
                                <Label id="status" label="Status" error={errorStatus}>
                                    <Input
                                        id="status"
                                        name="status"
                                        type="select"
                                        error={!!errorStatus}
                                        onChange={onChange.status || onChangeDefault}
                                        size={isMobile ? 'md' : 'lg'}
                                        value={valueStatus}
                                        values={statusList}
                                    />
                                </Label>
                            )}
                            <Label id="countries" label="Region" error={errorCountry}>
                                <Input
                                    id="countries"
                                    name="countries"
                                    type="multiple"
                                    error={!!errorCountry}
                                    onChange={onChange.country || onChangeDefault}
                                    size={isMobile ? 'md' : 'lg'}
                                    value={valueCountry}
                                    values={countries}
                                />
                            </Label>
                        </FormGroup>
                        <FormGroup title="Schedule">
                            <Label id="date_start" label="Start Date" error={errorGoLiveDate}>
                                <Input
                                    id="date_start"
                                    name="date_start"
                                    type="date"
                                    error={!!errorGoLiveDate}
                                    onChange={onChange.date_start || onChangeDefault}
                                    size={isMobile ? 'md' : 'lg'}
                                    value={valueGoLiveDate}
                                    withTime
                                />
                            </Label>
                            {valueExpiryDate && (
                                <Label id="date_end" label={this.renderEndDateLabel()} error={errorExpiryDate}>
                                    <Input
                                        id="date_end"
                                        name="date_end"
                                        type="date"
                                        error={!!errorExpiryDate}
                                        onChange={onChange.date_end || onChangeDefault}
                                        size={isMobile ? 'md' : 'lg'}
                                        value={valueExpiryDate}
                                        withTime
                                    />
                                </Label>
                            )}
                            {!valueExpiryDate && (
                                <NullLinkWrapper>
                                    <Link onClick={onChange.date_end_null}>Add End Date</Link>
                                </NullLinkWrapper>
                            )}
                        </FormGroup>
                        <FormGroup title="Content">
                            <Label id="media" label="Media" error={errorMedia}>
                                {(!valueMedia || valueMedia instanceof Array) && (
                                    <Input
                                        id="media"
                                        name="media"
                                        type="file"
                                        error={!!errorMedia}
                                        onChange={onChange.media || onChangeDefault}
                                        size={isMobile ? 'md' : 'lg'}
                                        value={valueMedia || []}
                                        accept="video/*"
                                    />
                                )}
                                {valueMedia instanceof Object && !(valueMedia instanceof Array) && (
                                    <StyledList data={[valueMedia]} display="name" onRemove={onChange.media_remove} />
                                )}
                            </Label>
                            <Label id="playlist" label="Playlist" error={errorPlaylist}>
                                {valuePlaylist && <StyledList data={[valuePlaylist]} display="name" onRemove={onChange.playlist_remove} />}
                                {!valuePlaylist && (
                                    <Input
                                        type="suggestions"
                                        onChange={onChange.playlist}
                                        onTextChange={onChange.playlist_change}
                                        options={optionsPlaylist}
                                        placeholder="Select Playlist..."
                                        size={isMobile ? 'md' : 'lg'}
                                    />
                                )}
                            </Label>
                        </FormGroup>
                        <FormGroup>
                            <Label id="notes" label="Notes" error={errorNotes}>
                                <Input
                                    id="notes"
                                    name="notes"
                                    type="textarea"
                                    error={!!errorNotes}
                                    onChange={onChange.notes || onChangeDefault}
                                    value={valueNotes}
                                    size={isMobile ? 'md' : 'lg'}
                                />
                            </Label>
                        </FormGroup>
                        <FormGroup>
                            <Column right width="100%">
                                {goBack && (
                                    <Button theme="light" onClick={goBack}>
                                        Cancel
                                    </Button>
                                )}
                                <Button onClick={onSubmit}>{this.submitLabel}</Button>
                            </Column>
                        </FormGroup>
                    </Form>
                </FrameContent>
            </Frame>
        )
    }
}

export default withSize(ContentPushForm)
